module.exports = __webpack_public_path__ + "static/media/loader.4e3f4d4a.svg";